import { TableCell, styled } from '@mui/material'

export const StyledHeaderTableCell = styled(TableCell)(
  ({ theme: { spacing }, role }) => ({
    padding: 0,
    paddingLeft: role ? 0 : spacing(1.25),
  }),
)
